import store from '../../store.js' ;
import axios from 'axios' ;
import * as auth from '../services/auth.js' ;
import VueSweetalert2 from 'vue-sweetalert2';

export function https () {
    const instance =  axios.create ( {
        baseURL : store.state.apiURL ,
        headers : {
            Authorization : auth.preference() ,
        }
    })  ;

    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        // console.log/(error.message);
        if(window.location.pathname !== '/' && error.message === 'Request failed with status code 401') {
            auth.removeLocalStorage();
            window.alert("Please login");
            window.location.reload()
        }
    });

    return instance;
}

export function httpsFile () {
    const instance2 = axios.create ( {
        baseURL : store.state.apiURL ,
        headers : {
            Authorization : auth.preference() ,
            'Content-Type' : 'multipart/form-data' ,
        }
    } ) ;

    instance2.interceptors.response.use(response => {
        return response;
    }, error => {
        // console.log(error.message);
        if (error.message === 'Request failed with status code 401') {
            auth.removeLocalStorage();
            window.alert("Please login");
            window.location.reload()


        }
    });

    return instance2;
}